<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <el-button
        v-if="!showOnly && !onlyView"
        small
        class="mb-3"
        color="primary"
        icon="pridėti"
        title="Pridėti prokuristą"
        :loading="loading"
        @click.native.stop="newProcurator()"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        class="mb-4 custom-table"
        :loading="loading"
        :headers="headers"
        :items="formData.procurators"
        :hide-default-footer="true"
        :items-per-page="1000"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal'),
        }"
      >
      <!--  -->
      <template #[`item.index`]="{ item, index }">
          <td class="pr-0 pl-2">{{ formatedIndex(index) }}</td>
      </template>
      <template #[`item.code`]="{ item }">
          {{ item.code || item.iltu_code }}
      </template>
      <template #[`item.contact_row`]="{ item, index }">
          <td v-if="!contactLoading"><person-contact-row :item="formData.procurators[index]"></person-contact-row></td>
      </template>
      <!--  -->
       <template #[`item.mandate_person`]="{ item }">
          <div :key="`${item.id}_ckbox`" class="nowrap">
           <el-checkbox
            :disabled="onlyView"
            @change="checkboxChange(item)"
            :value="item.selected"
            class="mt-0"
        />
          </div>
        </template>
      <!--  -->
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-table-action
              :item="setEdit(item, 'procurators')"
              @editContacts="editContacts(item)"
              @deleteItem="deleteItem({ item, type: 'procurators' })"
              @showPersonDocument="showPersonDocument(item)"
            />
          </div>
        </template>

      </v-data-table>
    </v-col>
    <!-- modal  -->
    <modal-delete
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      :additionalData="formData"
      @addPersonData="addPerson"
      checkBeforeAddRaw
      showForeignerPp
      mandate
    />
    <modal-contact-form
      v-if="showContactModal"
      v-model="showContactModal"
      :item="selectedContact"
      @reloadContact="reloadContact"
    />
    <modal-person-document
      v-if="showPersonDocumentModal"
      v-model="showPersonDocumentModal"
      :item="selectedPersonDocument"
      :readonly="onlyView"
      upload-mode="array"
      @files-added-to-person="handlePersonDocumentFilesAdded"
      @file-removed-from-person="handlePersonDocumentFileRemoved"
    />
  </v-row>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalContactForm from '@/components/modals/ModalContactForm.vue'
import ModalPersonDocument from '@/components/modals/ModalPersonDocument.vue'
import PersonContactRow from '@/components/iregTableRows/PersonContactRow.vue'
import math from '@/mixins/math'

export default {
  name: 'ProcuratorsForm',
  components: {
    ModalAddPerson,
    ModalDelete,
    ModalContactForm,
    ModalPersonDocument,
    PersonContactRow,
  },
  mixins: [math],
  props: {
    formData: [Array, Object],
    showOnly: Boolean,
    onlyView: Boolean,
    canEditContacts: Boolean,
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      showAddPerson: false,
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      showContactModal: false,
      selectedContact: {},
      contactLoading: false,
      showPersonDocumentModal: false,
      selectedPersonDocument: {},
    }
  },
  created(){
   if(this.formData.in_journal_type == '423'){
     this.setPersonId()
   }
  },
  computed: {
    togetherList() {
      return [
        { label: 'Veikimas kartu', value: true },
        { label: 'Veikimas atskirai', value: false },
      ]
    },
    showOperationProcuratorsType() {
      return this.formData.procurators?.length > 1
    },
    headers() {
      let headers = [
        {
          text: '',
          align: 'start',
          value: 'index',
          sortable: false,
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Asmens dokumentas'),
          align: 'start',
          value: 'person_document_kind_title_lt',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
      if (this.formData.in_journal_type == '423'){
       headers.unshift({
          text: this.$t('Atsisakantis prokuristas'),
          align: 'start',
          sortable: false,
          value: 'mandate_person',
          width: '2rem'
        })
      }
      return headers
    },
  },
  methods: {
    showPersonDocument(item) {
      this.selectedPersonDocument = item
      this.showPersonDocumentModal = true
    },
    reloadContact() {
      this.contactLoading = true;
      this.$nextTick(() => {
        this.contactLoading = false
      })
    },
    formatedIndex(index, subIndex) {
      if (subIndex != undefined) {
        this.formData.procurators[index].jur_representers[subIndex].order_no =
          subIndex + 1
        return `${index + 1}.${subIndex + 1}.`
      }
      this.formData.procurators[index].order_no = index + 1
      return `${index + 1}.`
    },
    dataPaproviderInProcurators(){
      return this.formData.procurators.filter((x) => x.amn_id == this.formData.data_provider.amn_id).length > 0
    },
    setPersonId(){
      if(this.formData.mandate_person_id){
        let item = this.formData.procurators.filter((x) => x.id == this.formData.mandate_person_id)[0]
        this.checkboxChange(item)
      }
      else if (this.dataPaproviderInProcurators()) {
        let item = this.formData.procurators.filter((x) => x.amn_id == this.formData.data_provider.amn_id)[0]
        this.checkboxChange(item)
      } else {
        let item = this.formData.procurators[0]
        this.checkboxChange(item)
      }
    },
    checkboxChange(item) {
      this.formData.procurators.map(procurator =>{
        this.$set(procurator, 'selected', false)
      })
       this.$nextTick(() => {
        this.formData.mandate_person_id = item.id
        this.$set(item, 'selected', true)
      })
    },
    setEdit(item, type) {
      this.$set(item, 'showPersonDocument', (item.person_documents && item.person_documents.length) || item.person_document_files || item.person_document_kind_id)
      if(this.showOnly || this.onlyView){
        item.canDelete = false
        this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
        return item
      }
      item.canDelete = true
      item.canEditContacts = this.canEditContacts
      return item
    },
    editContacts(item) {
      item.phone_number_prepend = item.phone_number_prepend || '+370'
      item.phone_number = item.phone_number || ''
      item.email_address = item.email_address || ''
      this.selectedContact = item
      this.showContactModal = true
    },
    newProcurator() {
      this.modalType = 'procurators'
      this.showAddPerson = true
    },
    addPerson(item) {
      if (this.formData.procurators.filter((procurator) => procurator.amn_id == item.amn_id).length > 0) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
      }
      this.formData.procurators.push(item)
      this.showAddPerson = false
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      const index = this.formData[item.type].findIndex(
        (formItem) => formItem.amn_id === item.item.amn_id
      )
      if (index > -1) {
        this.formData[item.type].splice(index, 1)
      }
      this.showDelete = false
    },

    handlePersonDocumentFilesAdded(addedFiles) {
      // Files have been added to the person's file array
      // The files are already added to selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', `${addedFiles.length} file(s) added to person document`)
    },

    handlePersonDocumentFileRemoved(removedFile) {
      // File has been removed from the person's file array
      // The file is already removed from selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', 'File removed from person document')
    },
  },
}
</script>

<style>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

</style>
